import { useRouter } from "next/dist/client/router";
import Join from "@/components/egroups/GroupsJoin";
import Head from "next/head";
function JoinPage(props: any) {
    let router = useRouter();

    if (!router.isReady) return null;
    return (
        <>
            <Head>
                <title>
                    Find an eGroup – Elevation Church Connection Center
                </title>
            </Head>
            <Join router={router} {...props} />
        </>
    );
}
JoinPage.wrapperClassName =
    "egroups flex flex-column extra-high-minus-menu flex-justify-center p-x-spacer-md";
export default JoinPage;
